module.exports = __webpack_public_path__ + "49d557dbf479250e7e4d63b0379a9633.png";